export default __webpack_public_path__ + "b7c5ca6236969793747b43f6f9ea2647.svg";